import { useNavigate } from "react-router";
import { useShallow } from "zustand/react/shallow";

import { api } from "@api";
import { useNotifyPromise } from "@hooks";
import { routePath } from "@routes/path.ts";
import {
  IAuthStepEnum,
  useAuthStore,
} from "@templates/authManagement/authStore";
import { ResetPasswordForm } from "@templates/authManagement/resetPasswordForm";

import type { IResetPasswordFormSchema } from "@templates/authManagement/resetPasswordForm";

export function ResetPasswordView() {
  const notifyMutate = useNotifyPromise();
  const navigate = useNavigate();

  const reqId = useAuthStore(
    useShallow((state) => state.forgetPasswordMeteData.reqId),
  );

  const { mutateAsync: mutate, isPending } =
    api.auth.passwordReset.setPassword.usePost();

  const onSubmit = (values: IResetPasswordFormSchema) => {
    notifyMutate(
      mutate(
        {
          pathParam: undefined,
          new_password: values.newPassword,
          reset_token: reqId,
        },
        {
          onSuccess: () => {
            navigate(
              routePath.authManagement.auth({
                type: IAuthStepEnum.LOGIN?.toString(),
              }),
            );
          },
        },
      ),
    ).catch(() => {});
  };

  return <ResetPasswordForm onSubmit={onSubmit} isLoading={isPending} />;
}
